import { useCallback, useRef } from 'react';
import { debounce } from 'lodash-es';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { useFormikContext } from 'formik';

export const FormikOnChangeObserver = ({ delay, onChange }) => {
  const { values } = useFormikContext();
  const isFirstRun = useRef(true);
  //eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedOnChange = useCallback(
    debounce(async () => {
      await onChange?.(values);
    }, delay),
    []
  );

  useDeepCompareEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    if (delay > 0) {
      (async () => {
        await debouncedOnChange(values);
      })();
    } else {
      onChange?.(values);
    }
  }, [values]);

  return null;
};
